import { FC, SVGProps } from "react";

interface BasketSvgProps extends SVGProps<SVGSVGElement> {
  variant?: "small" | "large" | "filled";
}

const BasketSvg: FC<BasketSvgProps> = ({ variant = "small", ...props }) => (
  <>
    {variant === "large" && (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props} viewBox="0 0 24 24">
        <path
          stroke="#CE212B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M16 7V4.75c0-.69-.56-1.25-1.25-1.25h-5.5C8.56 3.5 8 4.06 8 4.75V7M18.74 7l-.955 12.423a2.25 2.25 0 0 1-2.243 2.077H8.459a2.25 2.25 0 0 1-2.244-2.077L5.26 7M20 7H4M12 12.188v4"
        />
      </svg>
    )}
    {variant === "small" && (
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <path
          stroke="#CE212B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M10.666 4.333v-1.5A.833.833 0 0 0 9.833 2H6.166a.833.833 0 0 0-.833.833v1.5M12.494 4.334l-.637 8.282A1.5 1.5 0 0 1 10.36 14H5.64a1.5 1.5 0 0 1-1.495-1.385l-.637-8.282M13.334 4.333H2.667M8 7.791v2.667"
        />
      </svg>
    )}
    {variant === "filled" && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5428 21.0061H8.45698C7.28078 21.0061 6.30288 20.1005 6.21267 18.9278L5.24707 6.375H18.7527L17.7871 18.9278C17.6969 20.1005 16.719 21.0061 15.5428 21.0061V21.0061Z"
          stroke="#CE212B"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0037 6.37521H3.99707"
          stroke="#CE212B"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.18602 2.99609H14.8134C15.4349 2.99609 15.9388 3.49998 15.9388 4.12156V6.3725H8.06055V4.12156C8.06055 3.82307 8.17912 3.5368 8.39019 3.32574C8.60126 3.11467 8.88752 2.99609 9.18602 2.99609Z"
          stroke="#CE212B"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99902 17.0041H14.0007"
          stroke="#CE212B"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </>
);
export default BasketSvg;
